/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForWorkFlowReconciller extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForWorkFlowReconciller");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForWorkFlowReconciller.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForWorkFlowReconciller>): BackgroundJobPayloadForWorkFlowReconciller {
        let obj = Object.assign(new BackgroundJobPayloadForWorkFlowReconciller(), model);
        BackgroundJobPayloadForWorkFlowReconciller.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForWorkFlowReconciller>): BackgroundJobPayloadForWorkFlowReconciller {
        if (!model) return null;
        return BackgroundJobPayloadForWorkFlowReconciller.newInstance(<BackgroundJobPayloadForWorkFlowReconciller> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForWorkFlowReconciller) {
        if (!obj) return;

        models.BackgroundJobPayloadForWorkFlowReconciller.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForWorkFlowReconciller): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForWorkFlowReconciller.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.scope) {
            models.WorkFlowReconcillationScopes.fixupPrototype(this.scope);
        }
    }

    /**
     * SubCategory for which the workflow which has to be generated.
     */
    entity_type: models.WorkFlowCategory;

    /**
     * Tenant id
     */
    tenant_id: string;

    scope: models.WorkFlowReconcillationScopes;

    /**
     * Mode for the workflow reconciliation.
     */
    mode: models.WorkFlowReconcileMode;

}
